const USER_READ_ALL = { scope: "User.Read.All", note: "people and their status" };
const ORGANIZATION_READ_ALL = { scope: "Organization.Read.All", note: "which licences the tenant holds" };
const AI_INTERACTION_READ_ALL = { scope: "AiEnterpriseInteraction.Read.All", note: "Copilot prompts and responses" };
const ACTIVITY_FEED_READ = { scope: "ActivityFeed.Read", note: "Office 365 Management APIs, NOT Microsoft Graph" };
const GROUP_READ_ALL = { scope: "Group.Read.All", note: "groups and membership" };

export const ENTRA_DIRECTORY_PERMISSIONS = [
    USER_READ_ALL,
    GROUP_READ_ALL,
    { scope: "Device.Read.All", note: "Entra-registered devices" },
    { scope: "DeviceManagementManagedDevices.Read.All", note: "Intune devices, reconciled with the above" },
    ORGANIZATION_READ_ALL,
    { scope: "AuditLog.Read.All", note: "sign-in and directory change history" },
];

export const COPILOT_ONLY_PERMISSIONS = [AI_INTERACTION_READ_ALL, ACTIVITY_FEED_READ];

export const COPILOT_GRAPH_PERMISSIONS = [AI_INTERACTION_READ_ALL, USER_READ_ALL, ORGANIZATION_READ_ALL];

export const COPILOT_MANAGEMENT_API_PERMISSIONS = [ACTIVITY_FEED_READ];

export const COPILOT_SHARED_WITH_DIRECTORY = COPILOT_GRAPH_PERMISSIONS.filter((permission) =>
    ENTRA_DIRECTORY_PERMISSIONS.includes(permission),
);

export const MANAGED_MICROSOFT_PERMISSION_GROUPS = [
    { caption: "Directory sync", permissions: ENTRA_DIRECTORY_PERMISSIONS },
    { caption: "Copilot capture", permissions: COPILOT_ONLY_PERMISSIONS },
];

export const MANAGED_MICROSOFT_PERMISSION_COUNT = MANAGED_MICROSOFT_PERMISSION_GROUPS.reduce(
    (sum, group) => sum + group.permissions.length,
    0,
);

export const BYO_COPILOT_PERMISSION_GROUPS = [
    { caption: "Microsoft Graph, Application permissions", permissions: COPILOT_GRAPH_PERMISSIONS },
    { caption: "Office 365 Management APIs, Application permissions", permissions: COPILOT_MANAGEMENT_API_PERMISSIONS },
];

export const MANAGED_MICROSOFT_PERMISSIONS_NOTE =
    "Origin's Microsoft app requests these permissions. One admin consent covers both directory sync and Copilot capture. Each stays off until you connect it in Origin.";
